module.exports = __webpack_public_path__ + "static/assets/8f129f81b3736bc300497a43dfa1232a.svg";